<div class="card">
    <div class="card-body d-flex flex-column justify-content-center align-items-center">
        <ng-container *ngIf="userInfo?.user.subscriptionStatus == 'canceled'; else free">
            <h4 class="text-center">Your subscription will be expire on <br>{{userInfo?.user?.stripeData?.subsciption?.expiryDate | date:'mediumDate'}}</h4>
            <h4 class="text-center">To resubscribe click below</h4>
            <div class="text-center">
                <button class="btn btn-primary" (click)="openLogin()">Subcribe Now</button>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #free>
    <h4>Subscription required to access this data.</h4>
    <div class="text-center">
        <button class="btn btn-primary" (click)="openLogin()">Subcribe Now</button>
    </div>
</ng-template>
